import classNames from 'classnames';
import { type PropsWithChildren, type ReactElement } from 'react';

import styles from './badge.module.scss';

export enum BadgeVariant {
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}

export type BadgeProps = {
  className?: string;
  icon?: ReactElement;
  variant?: BadgeVariant;
};

export const Badge = ({
  children,
  className,
  icon,
  variant,
  ...props
}: PropsWithChildren<BadgeProps>) => {
  return (
    <div
      className={classNames(className, styles['badge'], {
        [styles[`badge--${variant}`]]: variant,
      })}
      {...props}
    >
      {icon && <div className={styles['badge__icon-container']}>{icon}</div>}
      {children}
    </div>
  );
};

export default Badge;
